const stash = {
    show: false,
    medias: [],
    busy: false,
    activeAlbum: {},
    filter: 'all',
    // filter: {
    //     type: 'all',
    //     sort: 'desc'
    // },
    sidebar: false,
    selected: [],
    albums: [],
    hasMore: true,
    mediaSent: [],
    mediaSold: [],
    mediaFilesToGetInformation: [],
    showImageModal: false,
    showVideoModal: false,
    imageModalSource: '',
    containerClass: '',
    stashSelected: [],
    showMoveFolder: false,
    showAlbumModal: false,
    isUploading: false,
    freePreview: {},
    tabSelected: 'media',
    albumAction: '',
    stashSidebar: false,
    addMediaToAlbum: false,
    moveToAlbum: false,
    orderModal: false,
    albumGetMediaInfo: [],
    tempSelected: [],
    albumListScrollTopPosition: 0,
    reset: false,
    filterType: 'all', // all or custom
    sort: 'DESC',
    filterToDate: '', // date value for custom filterType
    currentPage: 1,
};

export default stash;
